//lib
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom"; // for routing - to do navigation between different components

//scss
import "./scss/components/_element.scss";
import "./scss/index.scss";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "react-range-slider-input/dist/style.css";
import "react-tooltip/dist/react-tooltip.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

//page
import Home from "./pages/home";

//component
import MainLayout from "./components/layout/main.layout";

import Consign from "./pages/consign";
import Showroom from "./pages/showroom";
import Profile from "./pages/profile";
import PurchaseJourney from "./pages/purchases";
import { HelmetProvider } from "react-helmet-async";
import Product from "./pages/product";
import ProductModal from "./pages/home/modals/product.modal";

import Consignments from "./pages/consignments";
import PolicyPage from "./pages/policy";
import { privacyPolicy } from "./content/privacy.policy.mjs";
import { reservationPolicy } from "./content/reservation.policy.mjs";

import TermsSections, { termsAndConditions } from "./content/terms.and.conditions";
import { AboutUs } from "./pages/company";

import EditorialPage from "./pages/company/editorial";
import { editorialPages } from "./pages/company/editorial.content";

import ReferralTracker from "./components/common/referral.tracker";
import PageMetadata from "./components/common/page.metadata";

function AppRoutes() {
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation;

  return (
    <>
      <ReferralTracker />
      <PageMetadata />
      <ToastContainer
        limit={1}
        autoClose={3000}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
      />

      {/* Page routes (render background page when modal opened) */}
      <Routes location={backgroundLocation || location}>
        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/consign"
          element={
            <MainLayout>
              <Consign />
            </MainLayout>
          }
        />
        <Route
          path="/workshop"
          element={
            <MainLayout>
              <Showroom />
            </MainLayout>
          }
        />
        <Route
          path="/profile"
          element={
            <MainLayout>
              <Profile />
            </MainLayout>
          }
        />
        <Route
          path="/purchases"
          element={
            <MainLayout className="purchase-layout">
              <PurchaseJourney />
            </MainLayout>
          }
        />
        <Route
          path="/consignments"
          element={
            <MainLayout className="purchase-layout">
              <Consignments />
            </MainLayout>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <MainLayout>
              <PolicyPage policy={privacyPolicy} />
            </MainLayout>
          }
        />
        <Route
          path="/reservation-policy"
          element={
            <MainLayout>
              <PolicyPage policy={reservationPolicy} />
            </MainLayout>
          }
        />

        <Route path="/terms-and-conditions" element={<MainLayout><PolicyPage policy={termsAndConditions}><TermsSections /></PolicyPage></MainLayout>} />
        <Route path="/terms-of-use" element={<Navigate to="/terms-and-conditions" replace />} />
        <Route path="/about-us" element={<MainLayout><AboutUs /></MainLayout>} />
        <Route path="/contact-us" element={<Navigate to="/about-us#contact" replace />} />
        {Object.entries(editorialPages).map(([path, page]) => (
          <Route key={path} path={path} element={<MainLayout><EditorialPage page={page} /></MainLayout>} />
        ))}

        {/* IMPORTANT: page fallback for refresh / direct URL */}
        <Route
          path="/car/:id"
          element={
            <MainLayout>
              <Product />
            </MainLayout>
          }
        />
        <Route
          path="/car-plate/:id"
          element={
            <MainLayout>
              <Product />
            </MainLayout>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {/* Modal routes (only when opened from a background page) */}
      {backgroundLocation && (
        <Routes>
          <Route path="/car/:id" element={<ProductModal />} />
          <Route path="/car-plate/:id" element={<ProductModal />} />
        </Routes>
      )}
    </>
  );
}

export default function App() {

  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}
